import React, { useEffect, useState } from 'react'
import { colors, breakpoints, transitions } from 'utils/utils'
import BackgroundImage from 'gatsby-background-image'
import styled from 'styled-components'

export default props => {

    const { image, data } = props

    const [ isShowAnimation, setShowAnimation ] = useState(false)

    useEffect(() => {
        const handleAnimationScroll = () => {
            const heroImage = document.querySelector('.heroImage')
            if(heroImage) {
                const windowTop = window.scrollY
                const windowBottom = window.scrollY + window.innerHeight
                const topHeroImage = heroImage.offsetTop
                const bottomHeroImage = heroImage.offsetTop + heroImage.offsetHeight
                if(bottomHeroImage > windowTop + 200 && topHeroImage < windowBottom - 200) {
                    setShowAnimation(true)
                } else {
                    setShowAnimation(false)
                }
            }
        }
        handleAnimationScroll()
        window.addEventListener("scroll", handleAnimationScroll)

        return () => {
            window.removeEventListener("scroll", handleAnimationScroll)
        }
    },[])

    return (
        <HeroImage className={isShowAnimation ? "heroImage show" : "heroImage"} >
            <BackgroundHeroImage className="hero-image" fluid={image}/>
            {data.text1 ? 
                <AnimatedText className="up-center border-left width-animation">
                    <div>
                        <h2>{data.text1}</h2>
                    </div>
                </AnimatedText>
            : ''}
            {data.text2 ? 
                <AnimatedText className="up-left border-bottom height-animation">
                    <div>
                        <h2>{data.text2}</h2>
                    </div>
                </AnimatedText>
            : ''}
            {data.text3 ? 
                <AnimatedText className="up-right border-top height-animation">
                    <div>
                        <h2>{data.text3}</h2>
                    </div>
                </AnimatedText>
            : ''}
            {data.text4 ? 
                <AnimatedText className="down-left border-bottom height-animation">
                    <div>
                        <h2>{data.text4}</h2>
                    </div>
                </AnimatedText>
            : ''}
            {data.text5 ? 
                <AnimatedText className="down-right border-top height-animation">
                    <div>
                        <h2>{data.text5}</h2>
                    </div>
                </AnimatedText>
            : ''}
            {data.text6 ? 
                <AnimatedText className="down-center border-right width-animation">
                    <div>
                        <h2>{data.text6}</h2>
                    </div>
                </AnimatedText>
            : ''}
        </HeroImage>
    )
}


const AnimatedText = styled.div`
    position: absolute;
    color: ${colors.primary};
    overflow: hidden;
    box-sizing: content-box;
    height: 5.5rem;
    width: 13rem;
    text-shadow: ${colors.quinary} .1rem .1rem .2rem;
    h2 {
        font-size: 1.3rem;
        ${breakpoints.md} {
            font-size: 1rem;
        }
    }
    div {
        position: absolute;
        height: auto;
        width: 13rem;
        box-sizing: border-box;
    }

    &.up {
        &-center {
            top: 10%;
            left: 43%;
            h2 {
                margin-top: 0;
            }
            div {
                padding-left: 1rem;
                padding-bottom: 1rem;
                right: 0;
            }
        }
        &-right {
            top: 30%;
            right: 5%;
            h2 {
                margin-top: 0;
            }
            div {
                padding-right: 1rem;
                padding-top: 1rem;
                bottom: 0;
            }
            text-align: right;
        }
        &-left {
            bottom: 60%;
            left: 5%;
            div {
                padding-right: 2rem;
                top: 0;
            }
        }
    }

    &.down {
        &-center {
            bottom: 10%;
            right: 43%;
            h2 {
                margin-top: 0;
            }
            div {
                padding-right: 1rem;        
                padding-bottom: 1rem;
                left: 0;
            }
            text-align: right;
        }
        &-right {
            top: 60%;
            right: 5%;
            h2 {
                margin-top: 0;
            }
            div {
                padding-left: 1rem;
                padding-top: 1rem;
                bottom: 0;
            }
            text-align: right;
        }
        &-left {
            bottom: 30%;
            left: 5%;
            div {
                padding-right: 2rem;
                top: 0;
            }
        }
    }

    &.width-animation {
        width: 100%;
        max-width: 0;
        transition: max-width .5s ease-in-out;
    }
    &.height-animation {
        height: 100%;
        max-height: 0;
        transition: max-height .5s ease-in-out;
    }
    

`

const HeroImage = styled.div`
    position: relative;
    width: 50%;    
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    ${breakpoints.md} {
        width: 100%;
        height: 30rem;
        order: 2;
        &.show {
            .hero-image {
                transform: scale(1);
                opacity: 0.5;
            }
            .width-animation {
                max-width: 13rem;        
            }
            .height-animation {
                max-height: 5.5rem;
            }        
            .border {
                &-left {
                    border-left: solid .1rem ${colors.quinary};
                }
        
                &-right {
                    border-right: solid .1rem ${colors.quinary};
                }
        
                &-top {
                    border-top: solid .1rem ${colors.quinary};
                }
        
                &-bottom {            
                    border-bottom: solid .1rem ${colors.quinary};
                }
            }
        }
    }
    &:hover {
        .hero-image {
            transform: scale(1);
            opacity: 0.5!important;
        }
        .width-animation {
            max-width: 13rem;        
        }
        .height-animation {
            max-height: 5.5rem;
        }        
        .border {
            &-left {
                border-left: solid .1rem ${colors.quinary};
            }
    
            &-right {
                border-right: solid .1rem ${colors.quinary};
            }
    
            &-top {
                border-top: solid .1rem ${colors.quinary};
            }
    
            &-bottom {            
                border-bottom: solid .1rem ${colors.quinary};
            }
        }
    }

    
`

const BackgroundHeroImage = styled(BackgroundImage)`
    height: 100%;
    width: 100%;
    margin: auto;
    transform: scale(1.2);
    opacity: 1;
    transition: ${transitions.button}, opacity .3s ease-in-out;

`